import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

const SEO = () => {
  const { t } = useTranslation()
  return (
    <Helmet title={t('appName')}>
      <meta name="description" content={t('metaDescription')} />
      <meta name="keywords" content={t('metaKeywords')} />
    </Helmet>
  )
}

export default SEO
